/* =====================================================================
   EverMount fountain PDP - custom behaviour
   Ported from atf-concepts/"Main EMF PDP template - type scale.html".

   Loaded only by sections/wt-fountain-boot.liquid, which is referenced only by
   templates/product.evermount-fountain-3.json. It cannot run on another product.

   Contents, in the order the prototype ran them:
     page-scale      root zoom doctrine (one composition, scaled per device band)
     delivery-eta    computed "Est. delivery by ..."
     kit-selector    Choose your set / filter add-on state machine -> window.WT_CART
     modals          Compare sets + the two help dialogs
     accordion       filled accordion headers
     sticky-atc      mirror of the buy box + show/hide
     nowrap-fit      measured type fitting below 1000px
     cross-sell-add  "Add to Order" on the Bundle & Save cards

   DEPENDS ON:
     window.WT_PRICING  emitted from Liquid by sections/wt-fountain-boot.liquid
     window.WTCart      from assets/wt-evermount-gifts.js (site-wide, via theme.liquid)
   ===================================================================== */

/* The theme editor re-renders a section by re-inserting its markup, script tags
   included, so this file can execute more than once per page. Without this guard the
   accordion would get a second click listener (listener 1 opens the row, listener 2
   sees it as already open and closes everything, so it never opens again) and every
   help dialog would be wired twice. Re-initialising after a re-render is handled
   deliberately, through the wt:buy-box-ready event below. */
if (window.__wtFountainJs) { /* already running */ } else {
window.__wtFountainJs = 1;
window.WTFountain = window.WTFountain || {};

/* ===================== delivery-eta ===================== */
/* The ETA was a hardcoded "Sat, September 5" that nothing ever updated, so the page
   advertised a delivery date in the past (and the sticky bar copied it verbatim).
   Compute it instead: today + handling + transit, skipping weekends, with the lead
   time in ONE place. The lead time is the "Handling + transit" setting on the
   EverMount buy box section, carried here on data-wt-lead-days. */
function wtDeliveryEta(){
  var el = document.querySelector('[data-ship-eta]');
  if(!el) return;
  var host = el.closest ? el.closest('[data-wt-lead-days]') : null;
  var LEAD_BUSINESS_DAYS = host ? parseInt(host.getAttribute('data-wt-lead-days'), 10) : 4;
  if(!(LEAD_BUSINESS_DAYS > 0)) LEAD_BUSINESS_DAYS = 4;

  /* Non-delivery days (owner 2026-09-17): weekends, Thanksgiving Day (fourth Thursday of
     November, worked out per year) and the dates listed on the buy box - "MM-DD" repeats every
     year, "YYYY-MM-DD" is one-off. Christmas Day ships as the default list. */
  var skipThanks = !host || host.getAttribute('data-wt-thanksgiving') !== 'false';
  var extra = {};
  ((host && host.getAttribute('data-wt-holidays')) || '12-25').split(',').forEach(function(s){
    s = s.trim(); if(!s) return;
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s) || /^(\d{1,2})-(\d{1,2})$/.exec(s);
    if(!m) return;
    var key = m.length === 4 ? m[1] + '-' + (+m[2]) + '-' + (+m[3]) : '*-' + (+m[1]) + '-' + (+m[2]);
    extra[key] = true;
  });
  function isThanksgiving(x){
    if(!skipThanks || x.getMonth() !== 10) return false;
    var first = new Date(x.getFullYear(), 10, 1).getDay();          // weekday of Nov 1
    var fourthThu = 1 + ((4 - first + 7) % 7) + 21;                  // Thursday = 4
    return x.getDate() === fourthThu;
  }
  function isHoliday(x){
    var m = x.getMonth() + 1, day = x.getDate();
    return extra['*-' + m + '-' + day] || extra[x.getFullYear() + '-' + m + '-' + day] || isThanksgiving(x);
  }
  var d = new Date();
  var added = 0;
  while(added < LEAD_BUSINESS_DAYS){
    d.setDate(d.getDate() + 1);
    var wd = d.getDay();
    if(wd !== 0 && wd !== 6 && !isHoliday(d)) added++;   // no weekend or holiday delivery
  }
  /* Owner 2026-09-10: full month name on desktop ("Wed, September 16"), abbreviated on
     mobile ("Wed, Sep 16") so the stock + delivery row fits on one line at 390px.
     Same 999px gate as the mobile type-scale CSS; re-evaluated on orientation change. */
  var longStr  = d.toLocaleDateString('en-US', { weekday:'short', month:'long',  day:'numeric' });
  var shortStr = d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' });
  var mq = window.matchMedia ? window.matchMedia('(max-width:999px)') : null;
  function paint(){ el.textContent = (mq && mq.matches) ? shortStr : longStr; }
  paint();
  if(mq){ if(mq.addEventListener) mq.addEventListener('change', paint); else if(mq.addListener) mq.addListener(paint); }
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wtDeliveryEta);
else wtDeliveryEta();
/* The buy box re-creates [data-ship-eta] on every theme-editor re-render; repaint it. */
document.addEventListener('wt:buy-box-ready', wtDeliveryEta);

/* ===================== kit-selector ===================== */
function wtInitKitSelector(){
  var W = document.querySelector('.wtsel'); if(!W) return;
  var money   = function(c){ return '$' + (c/100).toFixed(2); };
  var dollars = function(c){ return '$' + Math.round(c/100); };

  var CFG = window.WT_PRICING; if(!CFG) return;   // defined in the config block above
  var KITS = CFG.kits || {};
  var FILTER = CFG.filter || {};
  FILTER.plans = FILTER.plans || {};

  /* The kit keys are merchant-editable (the "Internal key" setting on each Kit block),
     so seeding state from the literal 'starter' meant renaming that field, clearing it,
     or deleting and re-adding the block left KITS[state.kit] undefined and the first
     money(k.price) threw, taking the entire buy box down with it. Take whatever the
     first kit block actually rendered. */
  var kitKeys = Object.keys(KITS);
  if(!kitKeys.length) return;                 /* no kit blocks: nothing to drive */

  /* Likewise the subscription. With no Seal plan on the filter product, plans is {} and
     defaultFreq is null, so every plan().first / plan().id below was a TypeError. The
     markup already omits the subscribe row in that case; start on one-time to match. */
  var planKeys = Object.keys(FILTER.plans);
  var HAS_PLANS = planKeys.length > 0;
  var GIFT_MIN = CFG.tiers.GIFT_MIN;      // cart total that unlocks the free mystery gift
  var GIFT_VALUE = CFG.tiers.GIFT_VALUE;  // its compare-at value, added to the stack when it qualifies
  /* Subscription prices are no longer computed from a percentage the page made up.
     wt-fountain-boot.liquid reads each Seal selling plan's real allocation out of
     Liquid, so `first` is exactly what Shopify will charge on this order and `renew`
     is exactly what it will charge on every one after it. If the discount changes in
     Seal, this page follows on the next page load and cannot advertise a price the
     cart will not honour. */
  var plan = function(){ return FILTER.plans[state.freq] || FILTER.plans[FILTER.defaultFreq] || null; };
  var subscribed = function(){ return state.mode === 'sub' && !!plan(); };

  /* A ?variant= link (Google Shopping, Meta catalog ads) must land on the kit it
     advertised (owner 2026-09-23): the buy box marks that kit's pill .sel in Liquid,
     so start there. No match, or a key the JSON does not know, keeps the first kit. */
  var selPill = W.querySelector('.pills .pill.sel');
  var seedKit = selPill && KITS[selPill.getAttribute('data-kit')] ? selPill.getAttribute('data-kit') : kitKeys[0];

  var state = {
    kit:  seedKit,
    on:   !!FILTER.variantId,
    mode: HAS_PLANS ? 'sub' : 'onetime',
    freq: FILTER.defaultFreq || planKeys[0]
  };

  var pills   = W.querySelectorAll('.pill');
  var tileNow = W.querySelector('.tiles .tile:first-child .tprice .now');
  var tileWas = W.querySelector('.tiles .tile:first-child .tprice s');
  var tileName= W.querySelector('.tiles .tile:first-child .tname');
  var priceSave = document.getElementById('priceSave');
  var giftsCount = document.getElementById('giftsCount');
  var mainSale = document.getElementById('mainSale');
  var mainCompare = document.getElementById('mainCompare');
  var tileMystery = document.getElementById('tileMystery');
  var tileImg = W.querySelector('.tiles .tile:first-child .timg img');
  var totLabel= document.getElementById('totLabel');
  var totWas  = document.getElementById('totWas');
  var totNow  = document.getElementById('totNow');
  var totSave = document.getElementById('totSave');
  var subLine = document.getElementById('subLine');
  var payLine = document.getElementById('payLine');

  var check   = document.getElementById('filterCheck');
  var drawer  = document.getElementById('filterDrawer');
  var fPrice  = document.getElementById('filterPrice');
  var fCompare= document.getElementById('filterCompare');
  var fSave   = document.getElementById('filterSave');
  var freqSel = document.getElementById('filterFreq');
  var modes   = W.querySelectorAll('.fadd-mode');
  var modesGroup = W.querySelector('.fadd-modes');
  var card    = document.getElementById('filterAddon');

  /* Resolved relative to the buy box rather than through the theme's generated
     #product-form-main-<productId>-<sectionId>, which changes when the theme is
     duplicated or the product is recreated. If it were null, the native-form fallback
     would submit without ever enabling its variant id. */
  var mainId  = (function(){
    var sect = W.closest('.shopify-section') || document;
    return sect.querySelector('product-form form input[name="id"]')
        || document.querySelector('product-form form input[name="id"]');
  })();

  var reduce  = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  var saveLong  = fSave ? fSave.querySelector('.fadd-save-v--long')  : null;
  var saveShort = fSave ? fSave.querySelector('.fadd-save-v--short') : null;
  // The badge used to live INSIDE the add-on's <label>, so clicking it activated the
  // checkbox and toggled the whole subscription; that was patched here with a
  // preventDefault. The badge is now a sibling of the label (see .fadd-main), so the
  // patch is gone: a click on the badge does nothing, and the help icon's own handler
  // still opens its dialog.

  function setSaveVariant(long){
    if(saveLong)  saveLong.classList.toggle('is-on', long);
    if(saveShort) saveShort.classList.toggle('is-on', !long);
  }

  function filterCharge(){ if(!state.on) return 0; return subscribed() ? plan().first : FILTER.base; }

  function drawerOpen(open){
    if(!drawer) return;
    if(reduce){ drawer.classList.toggle('open',open); drawer.style.maxHeight = open?'none':'0px'; if(open){drawer.removeAttribute('inert');} else {drawer.setAttribute('inert','');} return; }
    if(open){
      drawer.removeAttribute('inert');
      drawer.classList.add('open');
      drawer.style.maxHeight = drawer.scrollHeight + 'px';
      var done = function(e){ if(e.propertyName!=='max-height') return; if(state.on) drawer.style.maxHeight='none'; drawer.removeEventListener('transitionend',done); };
      drawer.addEventListener('transitionend',done);
    } else {
      drawer.setAttribute('inert','');
      drawer.style.maxHeight = drawer.scrollHeight + 'px';
      drawer.getBoundingClientRect();
      drawer.classList.remove('open');
      drawer.style.maxHeight = '0px';
    }
  }
  function remeasure(){ if(drawer && state.on) drawer.style.maxHeight = 'none'; } // drawer already open: refit to content, never re-clamp

  /* THE cart contract. Whatever the box is charging for is described here, and the cart
     drawer's Checkout button POSTs exactly this to /cart/add.js. Quantities are the
     drawer's business (it has its own steppers), so only the lines live here. */
  function renderCart(){
    if(mainId){ mainId.value = KITS[state.kit].id; mainId.removeAttribute('disabled'); }
    var kk = KITS[state.kit];
    window.WT_CART = {
      /* _wt_kit_name / _wt_kit_sub: hidden (underscore) properties, so checkout never
         shows them; the cart drawer relabels the fountain line from them ("Starter Kit"
         over "Fountain + 1 Filter") - see relabelKits() in wt-evermount-gifts.js. */
      kit:    { id: Number(kk.id),
                properties: kk.name ? { _wt_kit_name: 'EverMount - ' + kk.name, _wt_kit_sub: kk.sub || '' } : null },
      filter: state.on
        ? { id: Number(FILTER.variantId),
            selling_plan: subscribed() ? Number(plan().id) : null,
            /* HIDDEN (underscore) line note for the cart drawer only: "Ships every 2 months".
               wt-evermount-gifts.js renders it under the filter row in Rebuy's drawer.
               Underscore properties never print at checkout, where Shopify already
               shows the plan name and "First payment …, then … every …" (owner 2026-09-18). */
            properties: (subscribed() && plan() && FILTER.cartNote)
              ? { _wt_note: String(FILTER.cartNote).replace('{every}', plan().every || '') }
              : null }
        : null
    };
  }

  function render(){
    var k = KITS[state.kit], sub = subscribed();
    if(!k) return;
    pills.forEach(function(p){ var on = p.getAttribute('data-kit')===state.kit; p.classList.toggle('sel',on); p.setAttribute('aria-pressed', on?'true':'false'); });
    // Compare dialog: on the SELECTED card, bold every line the other set does not have
    // ("6 replacement filters"), so the difference reads at a glance whichever set is chosen.
    var cmpCards = [].slice.call(document.querySelectorAll('#cmpModal .cmp-card'));
    /* li.cmp-gift (the mystery-gift row) is owned by wt-bundle.js: shown per card by
       threshold and bolded on the selected card; it is left out of the shared-row test. */
    var cmpRows = cmpCards.map(function(c){ return [].map.call(c.querySelectorAll('.cmp-kl li:not(.cmp-gift)'), function(li){ return li.textContent.replace(/\s+/g,' ').trim().toLowerCase(); }); });
    cmpCards.forEach(function(c, ci){
      var sel = c.getAttribute('data-kit')===state.kit;
      c.classList.toggle('cmp-card--sel', sel);
      [].forEach.call(c.querySelectorAll('.cmp-kl li:not(.cmp-gift)'), function(li, ri){
        var txt = cmpRows[ci][ri];
        var shared = cmpRows.every(function(rows, oi){ return oi===ci || rows.indexOf(txt) !== -1; });
        li.classList.toggle('cmp-diff', sel && !shared);
      });
      // price the compare cards from the config too, so they can never drift from the box
      var ck = KITS[c.getAttribute('data-kit')], kp = c.querySelector('.cmp-kp');
      if(ck && kp){ kp.textContent = ''; kp.appendChild(document.createTextNode(money(ck.price) + ' '));
                    var s = document.createElement('s'); s.textContent = dollars(ck.was); kp.appendChild(s); }
      // ...and the savings badge beside the price (a percentage off the bought-separately
      // value; wt-bundle.js repaints it from the add-on-inclusive totals when that runs)
      var pill = c.querySelector('.cmp-pill');
      if(ck && pill) pill.textContent = ck.was > ck.price ? 'SAVE ' + Math.round((ck.was - ck.price) / ck.was * 100) + '%' : '';
    });
    // the mystery tile's compare-at is GIFT_VALUE; it was written out a second time in markup
    if(tileMystery){
      var mys = tileMystery.querySelector('.tprice s');
      if(mys) mys.textContent = dollars(GIFT_VALUE);
    }
    if(tileNow) tileNow.textContent = money(k.price);
    if(tileWas) tileWas.textContent = dollars(k.cmp);
    if(tileMystery) tileMystery.hidden = (k.price + filterCharge()) < GIFT_MIN;
    /* Outside the tileMystery branch on purpose: a merchant who deletes the threshold
       tile still has free tiles to count, and leaving #giftsCount empty also wiped the
       sticky bar's gift text, which mirrors it. */
    // the hairline divider belongs to the last VISIBLE tile, and :last-child is structural
    var shown = [].filter.call(W.querySelectorAll('.tiles .tile'), function(t){ return !t.hidden; });
    shown.forEach(function(t,i){ t.classList.toggle('tile--last', i === shown.length - 1); });
    if(giftsCount){
      var free = shown.filter(function(t){ return t.querySelector('.tprice .free'); }).length;
      giftsCount.textContent = free + ' Free Gift' + (free === 1 ? '' : 's');
    }
    if(mainSale) mainSale.textContent = money(k.price);
    if(mainCompare) mainCompare.textContent = money(k.cmp);
    if(priceSave){
      /* Real saving of the selected kit, from Shopify's compare-at price. The label
         template comes from the section setting ("SAVE {pct}%"); no sale, no badge. */
      var savePct = k.cmp > k.price ? Math.round((k.cmp - k.price)/k.cmp*100) : 0;
      var tpl = priceSave.getAttribute('data-wt-tpl') || 'SAVE {pct}%';
      priceSave.textContent = tpl.replace('{pct}', savePct);
      priceSave.hidden = savePct <= 0;
    }
    if(tileName && k.tile) tileName.textContent = k.tile;
    if(tileImg && k.img && !tileImg.src.endsWith(k.img.replace('../',''))){
      tileImg.src = k.img;
      tileImg.alt = k.tile;
    }

    modes.forEach(function(m){ var a = m.getAttribute('data-mode')===state.mode; m.classList.toggle('is-active',a); var rb = m.querySelector('.fadd-mbox'); if(rb){ rb.setAttribute('aria-checked', a?'true':'false'); rb.setAttribute('tabindex', a?'0':'-1'); } });
    if(freqSel) freqSel.value = state.freq;
    if(fPrice) fPrice.textContent = sub ? money(plan().first) : money(FILTER.base);
    /* The "25% OFF 1st order" badge used to be a literal. It is now rendered from the
       plan's actual first-order discount through the template the section setting
       supplies, so the badge and the charge can never disagree. */
    /* Dialog subtitle: always the plan's own numbers (the dialog describes the subscription
       even while "One-time" is selected), so it never reads "Save 0%". */
    var dp = plan() || (planKeys.length ? FILTER.plans[planKeys[0]] : null);
    [].forEach.call(W.querySelectorAll('.ft-sub[data-wt-tpl], .fadd-subhead-t[data-wt-tpl]'), function(el){
      var t = el.getAttribute('data-wt-tpl').replace(/\{pct\}/g, String(dp ? dp.firstPct : 0)).replace(/\{renew\}/g, String(dp ? dp.pct : 0));
      if(el.textContent !== t) el.textContent = t;
    });
    [].forEach.call(W.querySelectorAll('.fadd-save-t[data-wt-tpl]'), function(el){
      var txt = el.getAttribute('data-wt-tpl').replace(/\{pct\}/g, String(sub ? plan().firstPct : 0));
      if(el.textContent !== txt) el.textContent = txt;
    });
    if(fCompare){ fCompare.textContent = money(FILTER.base); fCompare.hidden = !sub; }
    if(fSave) fSave.hidden = !sub;
    setSaveVariant(state.on);

    var total = k.price + filterCharge();
    var qualifies = total >= GIFT_MIN;   // the gift is unlocked by cart total, not by kit
    var was   = k.was + (state.on ? FILTER.base : 0) + (qualifies ? GIFT_VALUE : 0);
    if(card) card.classList.toggle('selected', state.on);
    if(totLabel) totLabel.textContent = state.on ? 'Total today:' : 'Total:';
    if(totWas) totWas.textContent = dollars(was);
    if(totNow) totNow.textContent = money(total);
    if(totSave) totSave.textContent = 'SAVE ' + Math.round((was - total)/was*100) + '%';

    if(subLine){
      if(state.on && sub && plan()){ subLine.hidden = false; subLine.textContent = 'then ' + money(plan().renew) + ' every ' + plan().every + ' \u00b7 cancel anytime'; }
      else subLine.hidden = true;
    }
    if(payLine) payLine.hidden = (state.on && sub); // Shop Pay Installments excludes subscriptions
    renderCart();
  }

  
  /* Kit -> gallery. The theme's product-gallery scrolls to a variant's featured image when
     the product form receives "variant:change" (the theme's own variant picker sends it;
     the kit pills replace that picker). Media id + position come from the variant in
     Shopify, so "the picture for this kit" is whatever image is set on the variant. */
  function syncGallery(prevKit){
    var form = mainId && mainId.form, k = KITS[state.kit], pk = KITS[prevKit];
    if(!form || !k || !k.media) return;
    try{
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: {
        formId: form.id,
        variant: { id: Number(k.id), featured_media: k.media },
        previousVariant: { id: pk ? Number(pk.id) : null, featured_media: pk ? pk.media : null }
      }}));
    }catch(e){}
  }

  pills.forEach(function(p){ p.addEventListener('click', function(){ var k=p.getAttribute('data-kit'); if(!k || k===state.kit) return; var prev=state.kit; state.kit=k; render(); remeasure(); syncGallery(prev); }); });
  if(check){ check.addEventListener('change', function(){ state.on=check.checked; check.setAttribute('aria-expanded', state.on?'true':'false'); render(); drawerOpen(state.on); }); }
  modes.forEach(function(m){ m.addEventListener('click', function(){ var mode=m.getAttribute('data-mode'); if(mode===state.mode) return; state.mode=mode; render(); remeasure(); }); });
  if(modesGroup){ modesGroup.addEventListener('keydown', function(e){
    if(e.target && e.target.tagName==='SELECT') return; // let the frequency dropdown handle its own keys
    var arrow = e.key==='ArrowDown'||e.key==='ArrowUp'||e.key==='ArrowLeft'||e.key==='ArrowRight';
    var activate = e.key===' '||e.key==='Enter';
    if(!arrow && !activate) return;
    e.preventDefault();
    if(arrow){ state.mode = state.mode==='sub' ? 'onetime' : 'sub'; }
    else { var t=e.target.closest('.fadd-mode'); if(!t) return; if(t.getAttribute('data-mode')===state.mode) return; state.mode=t.getAttribute('data-mode'); }
    render(); remeasure();
    var rb=W.querySelector('.fadd-mode.is-active .fadd-mbox'); if(rb) rb.focus();
  }); }
  if(freqSel){ freqSel.addEventListener('change', function(){ state.freq=freqSel.value; render(); }); }

  // initial: checked, drawer open (owner: subscription on by default)
  if(check){ check.checked = state.on; check.setAttribute('aria-expanded', state.on?'true':'false'); }
  if(drawer){
    if(state.on){ drawer.classList.add('open'); drawer.style.maxHeight='none'; drawer.removeAttribute('inert'); }
    else { drawer.classList.remove('open'); drawer.style.maxHeight='0px'; drawer.setAttribute('inert',''); }
  }
  render();

  /* wt-fountain-buy-box.liquid re-wraps the price spans when the theme re-renders
     price-list (variant change, section re-render) and announces it here. The old
     nodes are gone, so re-resolve before repainting or the kit price silently stops
     updating and the page shows the raw variant price instead. */
  /* Bound once for the life of the page, not once per init: the buy-box section can be
     re-rendered by the theme editor, and stacking a listener per re-render would repaint
     the price once for every time the section had ever been edited. */
  if(!wtInitKitSelector.priceBound){
    wtInitKitSelector.priceBound = 1;
    document.addEventListener('wt:price-rewrapped', function(){
      if(!wtInitKitSelector.current) return;
      wtInitKitSelector.current();
    });
  }
  wtInitKitSelector.current = function(){
    mainSale    = document.getElementById('mainSale');
    mainCompare = document.getElementById('mainCompare');
    priceSave   = document.getElementById('priceSave');
    render();
  };
}
WTFountain.initKitSelector = wtInitKitSelector;
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wtInitKitSelector);
else wtInitKitSelector();
/* wt-fountain-buy-box.liquid fires this after it has (re-)moved its markup into the
   product column, which is the only moment the elements below exist in their final
   place. */
document.addEventListener('wt:buy-box-ready', wtInitKitSelector);

/* ===================== modals ===================== */
/* Both help panels are centred dialogs hosted on <body>, so no overflow:hidden
   ancestor can clip them and the scrim covers the whole page. */
(function(){
  /* Re-runnable and idempotent. The dialogs are moved onto <body> and their triggers
     stay in the buy box, so when the theme editor re-renders that section the old
     dialogs are orphaned on <body> while the new triggers have no handlers. Clear the
     orphans, then wire whatever is on the page now. */
  function init(){
    [].forEach.call(document.querySelectorAll('body > .fadd-tip[data-wt-orphan]'), function(n){ n.remove(); });
    [].forEach.call(document.querySelectorAll('.wtsel .fadd-help'), function(h){
      if(h.__wtWired) return; h.__wtWired = 1; wire(h);
    });
    [].forEach.call(document.querySelectorAll('.wtsel [data-modal]'), function(trigger){
      if(trigger.__wtWired) return; trigger.__wtWired = 1;
      var tip = document.getElementById(trigger.getAttribute('data-modal'));
      if(!tip) return;
      tip.setAttribute('data-wt-orphan', '');
      document.body.appendChild(tip);
      wireModal(trigger, tip);
    });
  }
  WTFountain.initModals = init;
  document.addEventListener('wt:buy-box-ready', init);

  function scrim(){
    var el = document.querySelector('.ft-scrim');
    if(!el){ el = document.createElement('div'); el.className = 'ft-scrim'; document.body.appendChild(el); }
    return el;
  }

  // A full panel is a dialog, not a tooltip: click to open, centred over a scrim,
  // closed by the X, the scrim or Escape, with focus handed over and handed back.
  var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* Everything on the page that is NOT the dialog or its scrim, so a screen reader and
     the Tab key both stop at the dialog. These three panels declared role="dialog"
     aria-modal="true" and trapped nothing, so Tab walked straight out into the page
     behind the scrim. Nodes that are ALREADY inert are skipped, so hide() cannot
     un-inert something that was inert before the dialog opened. */
  function backdropNodes(tip, veil){
    return [].filter.call(document.body.children, function(n){
      return n !== tip && n !== veil && n.nodeType === 1 && !n.hasAttribute('inert');
    });
  }

  function wireModal(help, tip){
    var veil = scrim(), closeBtn = tip.querySelector('.ft-close'), msg = tip.querySelector('.fadd-tip-msg');
    var prevOverflow = '';
    var muted = [];
    function isOpen(){ return tip.classList.contains('is-open'); }
    /* SPEED: images inside a dialog carry data-wt-src instead of src so they are not
       fetched during page load (loading="lazy" did not prevent it: a closed dialog sits
       within lazy-load distance). Copied across once, on the first sign of intent
       (pointer over / focus on the trigger) so the picture is usually in cache before
       the dialog opens, and again in show() as the guarantee. */
    function hydrate(){
      [].forEach.call(tip.querySelectorAll('img[data-wt-src]'), function(im){
        im.setAttribute('src', im.getAttribute('data-wt-src')); im.removeAttribute('data-wt-src');
      });
    }
    help.addEventListener('pointerenter', hydrate);
    help.addEventListener('focus', hydrate);
    function show(){
      if(isOpen()) return;
      hydrate();
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      veil.classList.add('is-on');
      tip.classList.add('is-open');
      muted = backdropNodes(tip, veil);
      muted.forEach(function(n){ n.setAttribute('inert',''); });
      if(msg) msg.scrollTop = 0;
      if(closeBtn) closeBtn.focus();
    }
    function hide(){
      if(!isOpen()) return;
      tip.classList.remove('is-open');
      veil.classList.remove('is-on');
      muted.forEach(function(n){ n.removeAttribute('inert'); });
      muted = [];
      document.body.style.overflow = prevOverflow;
      try{ help.focus(); }catch(e){}
    }
    help.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(); });
    help.addEventListener('keydown', function(e){
      if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); e.stopPropagation(); show(); }
    });
    veil.addEventListener('click', hide);
    if(closeBtn) closeBtn.addEventListener('click', hide);
    document.addEventListener('keydown', function(e){
      if(!isOpen()) return;
      if(e.key === 'Escape'){ hide(); return; }
      if(e.key !== 'Tab') return;
      // `inert` alone still lets Tab escape to browser chrome and back into the page
      var f = tip.querySelectorAll(FOCUSABLE);
      if(!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      else if(!tip.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
    });
  }

  function wire(help){
    var tip = help.querySelector('.fadd-tip');
    if(!tip) return;
    tip.setAttribute('data-wt-orphan', '');    // so a re-render can sweep it up
    document.body.appendChild(tip);            // out of the clipping/flex context
    return wireModal(help, tip);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ===================== accordion ===================== */
(function(){
  /* Delegated from the document rather than bound to #wtacc. The accordion markup is
     moved into the product column by wt-fountain-buy-box.liquid and is replaced whole
     whenever the theme editor re-renders that section; a listener on the container went
     with it, and re-binding produced two listeners that cancelled each other out (the
     first opened the row, the second saw it open and closed everything). One listener,
     for the life of the page, whatever markup comes and goes underneath it. */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var hd = e.target.closest('.wtacc-hd');
    if(!hd) return;
    var acc = hd.closest('.wtacc');
    if(!acc) return;
    var row = hd.parentNode, wasOpen = row.classList.contains('is-open');
    [].forEach.call(acc.querySelectorAll('.wtacc-row'), function(r){
      r.classList.remove('is-open');
      var b = r.querySelector('.wtacc-hd'), d = r.querySelector('.wtacc-bd');
      if(b) b.setAttribute('aria-expanded','false');
      // collapsed bodies are clipped, not removed: inert keeps their links out of the
      // tab order and their text out of the accessibility tree
      if(d) d.setAttribute('inert','');
    });
    if(!wasOpen){
      row.classList.add('is-open');
      hd.setAttribute('aria-expanded','true');
      var open = row.querySelector('.wtacc-bd');
      if(open) open.removeAttribute('inert');
    }
  });
})();

/* ===================== sticky-atc ===================== */
/* Mobile meta-row fit (owner request 2026-09-10): show the "(384)" review count when the row
   "4.8 (384) · 3 free gifts · Delivery by …" fits on one line at the current width, hide it
   when it would overflow. Measured, not a breakpoint, so a longer date or a bigger count
   still resolves correctly. Re-runs on resize, on font load, and whenever the row's box
   changes (the bar is hidden until the buy box scrolls away, so the first layout can be 0). */
(function(){
  var bar = document.getElementById('wt-sticky-atc'); if(!bar) return;
  var micro = bar.querySelector('.wtsb-micro'); if(!micro) return;
  function fit(){
    if(!micro.clientWidth) return;                 /* not laid out yet (desktop, or bar not shown) */
    micro.classList.remove('is-tight');
    if(micro.scrollWidth > micro.clientWidth + 1) micro.classList.add('is-tight');
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if(window.ResizeObserver) new ResizeObserver(fit).observe(micro);
  /* The row's box is viewport-driven, so none of the above fire when the bar script
     rewrites the row's TEXT (live Loox count, ETA change, the month abbreviation crossing
     999px). The sync() below calls this after every write. */
  window.__wtsbFit = fit;
})();
(function(){
  var bar = document.getElementById('wt-sticky-atc'); if(!bar) return;
  /* Resolved from the buy box, not the theme's generated section id. The old
     `getElementById(...) || document` silently fell back to the WHOLE document when that
     id changed (theme duplicated, product recreated), so every lookup below started
     matching the first candidate anywhere on the page instead of inside the product
     section — a wrong thumbnail, a wrong Add to cart to mirror. */
  var main = (function(){
    var sel = document.querySelector('.wtsel');
    return (sel && sel.closest('.shopify-section'))
        || document.querySelector('.shopify-section--main-product')
        || document;
  })();
  var atc = main.querySelector('buy-buttons .button, .buy-buttons .button'); if(!atc){ return; }
  var W = main.querySelector('.wtsel');
  function q(s){ return main.querySelector(s); }
  function all(k){ return bar.querySelectorAll('[data-wtsb="'+k+'"]'); }
  function setText(k,v){ if(v==null) return; [].forEach.call(all(k), function(el){ if(el.textContent!==v) el.textContent=v; }); }
  var MONTHS = {January:'Jan',February:'Feb',March:'Mar',April:'Apr',June:'Jun',July:'Jul',August:'Aug',September:'Sep',October:'Oct',November:'Nov',December:'Dec'};
  function sync(){
    var was=q('#totWas'), now=q('#totNow'), save=q('#totSave'), gifts=q('#giftsCount');
    var tile=q('.wtsel .tiles .tile:first-child'); var eta=q('.shipeta strong'); var rev=q('.atf2-revtext');
    if(was) setText('was', was.textContent.trim());
    if(now) setText('now', now.textContent.trim());
    if(save) setText('save', save.textContent.trim());
    if(gifts){ var g = gifts.textContent.trim().replace(/\s+/g,' '); setText('gifts', g.charAt(0) + g.slice(1).toLowerCase()); }
    if(tile){ var n=tile.querySelector('.tname'), im=tile.querySelector('img'); if(n) setText('ttl', n.textContent.trim()); var ib=bar.querySelector('[data-wtsb="img"]'); if(im && ib && ib.getAttribute('src')!==im.getAttribute('src')) ib.setAttribute('src', im.getAttribute('src')); }
    if(eta){ var e = eta.textContent.trim().replace(/[A-Z][a-z]+/g, function(m){ return MONTHS[m]||m; }); setText('eta', e); }
    /* Rating source: the Loox widget, which is what the customer can actually SEE.
       This used to parse .atf2-revtext, but that row is display:none !important
       (see .atf2-reviews), so the bar was mirroring a hidden hardcoded string that
       no longer tracked the live widget. .atf2-revtext is kept only as a fallback
       for when the Loox script has not painted its attributes yet. */
    var lx = q('.loox-rating[data-rating]');
    var rating = lx && lx.getAttribute('data-rating');
    var count  = lx && (lx.getAttribute('data-raters') || lx.getAttribute('data-count'));
    if(!rating && rev){
      var m = rev.textContent.replace(/\s+/g,' ').match(/([\d.]+)\s*[^\d]+\s*([\d,]+)\s*reviews?/i);
      if(m){ rating = m[1]; count = m[2]; }
    }
    if(rating) setText('rating', rating);
    if(count){ setText('count', count); setText('reviews', '\u00b7 '+count+' reviews'); }
    if(window.__wtsbFit) window.__wtsbFit();     /* re-measure the mobile meta row after every text write */
  }
  var mo = window.MutationObserver ? new MutationObserver(function(){ window.requestAnimationFrame(sync); }) : null;
  function observe(){
    if(!mo) return;
    mo.disconnect();
    [W, q('.shiprow'), q('.atf2-revtext'), q('.loox-rating[data-rating]')].forEach(function(n){ if(n) mo.observe(n, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['src','hidden','data-rating','data-raters']}); });
  }
  sync();
  observe();

  /* The bar mirrors the buy box, so when the buy box is replaced the observer is
     watching detached nodes and the bar freezes on the last values it saw. `atc` and
     `main` belong to the theme's product section, which is not re-rendered, so only the
     .wtsel reference needs re-resolving. */
  document.addEventListener('wt:buy-box-ready', function(){
    W = main.querySelector('.wtsel');
    observe();
    sync();
  });
  /* The sticky bar's Add to cart forwards to the REAL one rather than doing its own
     /cart/add. That keeps one cart path for both buttons: the click submits the theme's
     product form, wt-evermount-gifts.js intercepts the submit, adds the kit + the filter
     line (with its selling plan) + the free gifts in one request, and opens the Rebuy
     Smart Cart. In the prototype this was a fallback behind the mock drawer's capture
     listener; with the mock gone it is the only path, which is what we want. */
  [].forEach.call(all('btn'), function(b){ b.addEventListener('click', function(){ atc.click(); }); });

  // show once the main Add to cart has scrolled above the viewport; hide when it comes back (or when we are still above it)
  var shown=false;
  function show(on){
    if(on===shown) return;
    shown=on;
    /* Never leave focus inside a subtree we are about to mark aria-hidden and then
       visibility:hidden — the browser would silently drop it to <body>, and the cart
       drawer would later try to restore focus to a button that is no longer there. */
    if(!on && bar.contains(document.activeElement) && document.activeElement.blur){
      document.activeElement.blur();
    }
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on?'false':'true');
  }
  // ...and retract again as soon as the page footer enters the viewport, so the bar is not
  // sitting over the footer while you are reading it. Scoped to the PAGE footer: the Rebuy
  // Smart Cart renders its own <footer> inside #rebuy-cart, which must not trigger this.
  var pageFoot = (function(){
    var fs = [].filter.call(document.querySelectorAll('footer'), function(f){
      return !f.closest('#rebuy-cart');       // Rebuy Smart Cart's own footer
    });
    // last one down the page wins; avoids depending on the theme's generated id or its
    // class name (which is shopify-section-group-footer-GROUP, easy to mistype)
    return fs.length ? fs[fs.length-1] : null;
  })();
  function footerInView(){
    if(!pageFoot) return false;
    var f = pageFoot.getBoundingClientRect();
    if(f.height < 1) return false;              // hidden/collapsed footer must not hide the bar
    return f.top <= (window.innerHeight || document.documentElement.clientHeight);
  }
  function check(){ var r = atc.getBoundingClientRect(); show(r.bottom < 0 && !footerInView()); }

  /* check() forces two synchronous layouts (a rect for the button, a rect for the footer),
     and the old code ran it on EVERY scroll event. Coalesce to at most one run per frame
     instead. The scroll listener has to stay: IntersectionObserver only reports threshold
     CROSSINGS, so an instant jump past the button — anchor link, scroll restoration,
     scrollTo — moves from not-intersecting to not-intersecting and notifies nothing,
     which left the bar stuck hidden. The observers stay too; they catch the cases where
     the boundary moves under a stationary viewport (lazy images, drawer reflow). */
  var raf = 0;
  function schedule(){
    if(raf) return;
    raf = window.requestAnimationFrame(function(){ raf = 0; check(); });
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(schedule, {threshold:0}).observe(atc);
    if(pageFoot) new IntersectionObserver(schedule, {threshold:0}).observe(pageFoot);
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});

  check();
})();

/* ===================== nowrap-fit ===================== */
/* NO-WRAP FIT (owner 2026-09-10) — mobile only (≤999px), pairs with rule 53 in the
   type-scale-mobile style block. Each group below names the on-screen copy it protects.
   ROLE: a SAFETY NET only. The page-wide zoom (mobile-scale script in <head>) keeps every
   phone on the 450px reference layout, where all of this copy already fits, so with the
   shipped copy this script never changes a size. It only steps in when runtime text grows
   past the reference (a "September 30" delivery date, a five-digit review count), and then
   only for that line, so the owner's proportions are never touched otherwise.
   How it works: the inline font-size (or zoom) it wrote last time is cleared, so the CSS
   size is the starting point; then the element is measured, and the size is stepped down
   in 0.25px steps (zoom in 1% steps) until the copy fits: `nowrap` groups until nothing
   overflows its box, `lines` groups until the text takes at most `max` lines. Every group
   writes ONE size to all of its members (the five bullets, both kit titles, the four
   trust labels, the stock + delivery pair) so siblings never read as different sizes.
   Re-runs on resize / orientation change, on font load, when the ≤999px query flips,
   whenever a measured box changes size, and whenever the copy is rewritten (delivery
   date, kit toggle changing the Total row, Loox count). Desktop is untouched: above
   999px every override is cleared and nothing is measured. */
(function(){
  var MAIN = '#wt-fountain [id$="__main"] ';
  var GROUPS = [
    /* product title "EverMount Battery-Operated Pet Water Fountain": ≤ 2 lines */
    {name:'title',   mode:'lines', max:2, min:14,
     apply: MAIN+'.product-info__block-item[data-block-type="title"] .product-title'},
    /* benefit bullets "100% Cordless. No wires or messes to worry about" ×5: 1 line each, one shared size */
    {name:'bullets', mode:'nowrap', min:8,
     apply: MAIN+'.atf2-benefits li', measure: MAIN+'.atf2-benefits li > span'},
    /* kit titles "Starter Kit" / "90-Day Hydration Kit": 1 line, one shared size */
    {name:'kits',    mode:'nowrap', min:8,
     apply: MAIN+'.wtsel .pill b'},
    /* "EverMount Replacement Filters (5-Pack)": ≤ 2 lines (base rule carries !important) */
    {name:'filter',  mode:'lines', max:2, min:8, important:true,
     apply: MAIN+'.wtsel .fadd-name'},
    /* Total today row: "Total today: $155 $94.99 SAVE 39%" on one line — whole row zooms */
    {name:'total',   mode:'zoom', min:0.5,
     apply: MAIN+'.wtsel .totline'},
    /* "Low stock available" + "Est. delivery by Wed, Sep 16": one row, one shared size */
    {name:'ship',    mode:'nowrap', min:8,
     apply: MAIN+'.shiprow .lowstock, '+MAIN+'.shiprow .shipeta', measure: MAIN+'.shiprow .shipeta p, '+MAIN+'.shiprow'},
    /* trust strip "Fast Shipping / 60-Day Trial / 24/7 Support / 24-Month Warranty": 1 line, one shared size */
    {name:'trust',   mode:'nowrap', min:6,
     apply: '#wt-fountain [id$="__product_icon_text_Pe4fA7"] .product-icon-wrapper .text p'},
    /* sticky bar, mobile layout: "4.8 (384) · 3 free gifts · Delivery by Wed, Sep 23" and the
       "ADD TO CART · $155 $96.99" button must never overflow the bar. Under the page zoom both
       are the 450 reference and never do; this is for an engine without CSS zoom, or a longer
       date. The bar's own is-tight step (hide "(384)") runs first; this zooms whatever is left. */
    {name:'stickymicro', mode:'zoom', min:0.6, apply: '#wt-sticky-atc .wtsb-micro'},
    {name:'stickybtn',   mode:'zoom', min:0.6, apply: '#wt-sticky-atc .wtsb-m .button'}
  ];
  var MQ = window.matchMedia('(max-width:999px)');
  var q = function(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); };

  function lineCount(el){
    var r = document.createRange(); r.selectNodeContents(el);
    var rects = r.getClientRects(), tops = [], i, t, n = 0, last = -1e9;
    for(i = 0; i < rects.length; i++){ if(rects[i].width > 0 && rects[i].height > 0) tops.push(rects[i].top); }
    tops.sort(function(a, b){ return a - b; });
    for(i = 0; i < tops.length; i++){ t = tops[i]; if(t - last > 4){ n++; last = t; } }
    return n;
  }
  function overflows(el){ return el.scrollWidth > el.clientWidth + 0.5; }
  function clear(els, g){
    els.forEach(function(el){ el.style.removeProperty(g.mode === 'zoom' ? 'zoom' : 'font-size'); });
  }
  function setSize(els, px, g){
    els.forEach(function(el){ el.style.setProperty('font-size', px + 'px', g.important ? 'important' : ''); });
  }

  function fitGroup(g){
    var apply = q(g.apply); if(!apply.length) return;
    var measure = g.measure ? q(g.measure) : apply;
    clear(apply, g);
    if(!MQ.matches) return;
    if(document.documentElement.getAttribute('data-wt-fit') === 'off') return;   /* debug switch: measure the raw layout */
    if(!measure.some(function(el){ return el.clientWidth > 0; })) return;   /* not laid out */

    if(g.mode === 'zoom'){
      var el = apply[0], z = 1, k = 0;
      while(overflows(el) && z > g.min && k++ < 60){
        z = Math.floor((z * el.clientWidth / el.scrollWidth) * 100) / 100 - 0.01;
        if(z < g.min) z = g.min;
        el.style.zoom = z;
      }
      return;
    }

    var bad = function(){
      return measure.some(function(el){
        return g.mode === 'lines' ? lineCount(el) > g.max : overflows(el);
      });
    };
    if(!bad()) return;
    var base = parseFloat(getComputedStyle(apply[0]).fontSize), size = base, k2 = 0;
    if(g.mode === 'nowrap'){
      /* one jump to the ratio the widest member needs, then settle by 0.25px steps */
      var ratio = 1;
      measure.forEach(function(el){ if(el.scrollWidth) ratio = Math.min(ratio, el.clientWidth / el.scrollWidth); });
      size = Math.floor(size * ratio * 4) / 4;
    }
    if(size < g.min) size = g.min;
    setSize(apply, size, g);
    if(bad()){
      /* still breaks: walk down */
      while(bad() && size > g.min && k2++ < 80){
        size = Math.max(g.min, size - 0.25);
        setSize(apply, size, g);
      }
    } else {
      /* the jump overshot (a fixed-width sibling gave back room as the text shrank): walk back up */
      while(size + 0.25 <= base && k2++ < 80){
        setSize(apply, size + 0.25, g);
        if(bad()){ setSize(apply, size, g); break; }
        size += 0.25;
      }
    }
  }

  function fitAll(){ GROUPS.forEach(fitGroup); }
  var raf = null;
  function schedule(){ if(raf) return; raf = requestAnimationFrame(function(){ raf = null; fitAll(); }); }

  fitAll();
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('load', schedule);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  if(MQ.addEventListener) MQ.addEventListener('change', schedule); else if(MQ.addListener) MQ.addListener(schedule);
  if(window.ResizeObserver){
    var ro = new ResizeObserver(schedule);
    GROUPS.forEach(function(g){ q(g.measure || g.apply).forEach(function(el){ ro.observe(el.parentElement || el); }); });
  }
  if(window.MutationObserver){
    var mo = new MutationObserver(schedule);
    GROUPS.forEach(function(g){ q(g.apply).forEach(function(el){ mo.observe(el, {childList:true, characterData:true, subtree:true}); }); });
  }
  window.__wtNowrapFit = fitAll;
})();

/* ===================== cross-sell-add ===================== */
/* ---- "Bundle & Save" cross-sell: Add to Order ----
   The button reads its own card for name / image / price, so nothing is duplicated.

   In the prototype this fed a mock cart drawer through window.WT_ADD_EXTRA /
   WT_OPEN_CART. In production the line goes straight into the Shopify cart and the
   Rebuy Smart Cart is told to reload and open, via window.WTCart (defined in
   wt-evermount-gifts.js, which loads site-wide).

   data-xsell-variant is filled from Liquid by the theme's cross-sell card. When it is
   empty the button opens the product page instead of inventing a variant id. */
(function(){
  /* Add a discount code to the cart without dropping one the shopper already has:
     /cart/update.js `discount` REPLACES the cart's codes with the list it is given. */
  function cartJSON(url, body){
    return fetch(url, body ? { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) }
                           : { headers:{ 'Accept':'application/json' } })
      .then(function(r){ if(!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function applyCode(code){
    return cartJSON('/cart.js').then(function(cart){
      var have = ((cart && cart.discount_codes) || []).map(function(d){ return String(d.code || ''); }).filter(Boolean);
      var up = code.toUpperCase();
      if(have.some(function(c){ return c.toUpperCase() === up; })) return cart;
      return cartJSON('/cart/update.js', { discount: have.concat(code).join(',') });
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.xsell-cta') : null;
    if(!b) return;
    e.preventDefault();

    var vid = b.getAttribute('data-xsell-variant') || '';
    var url = b.getAttribute('data-xsell-url') || '';
    var goProduct = function(why, err){
      console.warn('[xsell] ' + why + ' — opening the product page instead.', err || '');
      if(url) window.location.href = url;
    };

    if(!/^\d+$/.test(vid)) return goProduct('no data-xsell-variant on this CTA');
    if(!window.WTCart)     return goProduct('wt-evermount-gifts.js is not installed');

    if(b.disabled) return;
    b.disabled = true;
    b.setAttribute('aria-busy','true');
    var release = function(){ b.disabled = false; b.removeAttribute('aria-busy'); };

    var code = (b.getAttribute('data-xsell-code') || '').trim();
    window.WTCart.addLines([{ id: Number(vid), quantity: 1 }]).then(function(){
      /* The card's price comes from a discount code only this button applies (audit L7,
         2026-10-15): without it the line charged full price whenever no fountain was in
         the cart. Never fatal: the line is already in the cart either way. */
      return code ? applyCode(code)['catch'](function(e){ console.warn('[xsell] could not apply ' + code, e || ''); }) : null;
    }).then(function(){
      release();
      window.WTCart.refreshCart();
      window.WTCart.openCart();   /* waits for Smart Cart itself; falls back to /cart on its own */
    }, function(err){
      release();
      goProduct('could not add to cart', err);
    });
  });
})();


/* ===== FAQ: topic chips, one-open-at-a-time, CTA buttons =====
   The prototype hand-edited the theme's FAQ section: a row of topic chips under the heading,
   data-wt-topic on every accordion, one-open-at-a-time (see shut() below), and the
   "manual" / "contact" answers ending in a pill button instead of an inline link. The section
   file is the theme's own (shared by every page), so this is done here, on this template only.
   Topics are matched on the question text; a question no rule matches gets "support" and is
   never hidden by the chip filter in a way that loses it. */
(function(){
  var root = document.querySelector('[id$="__faq_pXEJHW"]');
  if(!root || root.querySelector('.wt-faq-chips')) return;
  var RULES = [
    ['filters',  /filter/i],
    ['cleaning', /water|fill|clean|dishwasher/i],
    ['trouble',  /dispens|turn(s|ed)? (on|off)|not working|automatically/i],
    ['support',  /manual|question|contact/i]
  ];
  var LABELS = { all:'All', filters:'Filters', cleaning:'Water & Cleaning', trouble:'Troubleshooting', support:'Support' };
  var items = [].slice.call(root.querySelectorAll('.accordion'));
  if(!items.length) return;
  var seen = {};
  items.forEach(function(item){
    var q = (item.querySelector('summary') || item).textContent || '';
    var topic = 'support';
    for(var i=0;i<RULES.length;i++){ if(RULES[i][1].test(q)){ topic = RULES[i][0]; break; } }
    item.setAttribute('data-wt-topic', topic); seen[topic] = true;
  });
  /* One-open-at-a-time is done by hand below, NOT with name="wt-faq" on the <details>.
     The native exclusive-accordion group strips `open` off the sibling behind the theme's
     back: its accordion-disclosure keeps aria-expanded as the source of truth for toggle(),
     so a natively-closed row still said "true", the next tap ran close() on an already
     closed row, and the question could never be opened again (live bug 2026-09-18). */
  function shut(d){
    var el = d.closest('accordion-disclosure');
    if(el && typeof el.close === 'function' && d.open) el.close();   /* theme's own animated close, keeps its state in sync */
    else d.open = false;
    d.setAttribute('aria-expanded','false');
  }
  var order = ['all','filters','cleaning','trouble','support'].filter(function(t){ return t==='all' || seen[t]; });
  var chips = document.createElement('div');
  chips.className = 'wt-faq-chips'; chips.setAttribute('role','group'); chips.setAttribute('aria-label','Filter questions by topic');
  chips.innerHTML = order.map(function(t){ return '<button type="button" class="wt-chip'+(t==='all'?' is-on':'')+'" data-topic="'+t+'" aria-pressed="'+(t==='all')+'">'+LABELS[t]+'</button>'; }).join('');
  var header = root.querySelector('.section-header');
  if(header && header.parentNode) header.parentNode.insertBefore(chips, header.nextSibling);
  else items[0].parentNode.insertBefore(chips, items[0]);

  root.addEventListener('click', function(ev){
    var chip = ev.target.closest('.wt-chip'); if(!chip || !root.contains(chip)) return;
    var topic = chip.getAttribute('data-topic');
    [].forEach.call(root.querySelectorAll('.wt-chip'), function(c){ var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    items.forEach(function(item){
      var show = topic === 'all' || item.getAttribute('data-wt-topic') === topic;
      item.hidden = !show;
      if(!show){ var d = item.querySelector('details'); if(d && d.open) shut(d); }
    });
  });
  /* `toggle` does not bubble, so listen in the capture phase. Re-sync aria-expanded to the
     real open state on every toggle as a belt-and-braces guard, then close the others. */
  root.addEventListener('toggle', function(ev){
    var d = ev.target; if(!(d instanceof HTMLDetailsElement)) return;
    if(!d.open){ d.setAttribute('aria-expanded','false'); return; }
    d.setAttribute('aria-expanded','true');
    items.forEach(function(item){
      var o = item.querySelector('details');
      if(o && o !== d && o.open) shut(o);
    });
  }, true);

  /* Inline "here" links -> a pill button on its own line, as the prototype had */
  function pill(a, label){
    var p = a.closest('p'); if(!p) return;
    var btn = document.createElement('a');
    btn.className = 'wt-faq-btn'; btn.href = a.href; btn.textContent = label;
    if(a.target) btn.target = a.target;
    if(a.target === '_blank') btn.rel = 'noopener';
    var cta = document.createElement('p'); cta.className = 'wt-faq-cta'; cta.appendChild(btn);
    a.remove();
    p.innerHTML = p.innerHTML.replace(/(?:\s|&nbsp;)+([!.?,])/g, '$1').replace(/\s{2,}/g,' ').replace(/\s+$/,'');
    if(!/[!.?]$/.test(p.textContent.trim())) p.appendChild(document.createTextNode('!'));
    p.parentNode.insertBefore(cta, p.nextSibling);
  }
  [].forEach.call(root.querySelectorAll('.accordion__content a'), function(a){
    var h = a.getAttribute('href') || '';
    if(/user-manual|\.pdf(\?|$)/i.test(h)) pill(a, 'Download manual');
    else if(/\/pages\/contact/i.test(h)) pill(a, 'Contact us');
  });
})();

/* VIDEO SECTIONS: the YouTube play path now lives in sections/video.liquid for every
   page (operator 2026-10-14); this file only keeps the iOS zoom correction in wt-fountain.css. */

} /* end __wtFountainJs guard */
